import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';

export const useUpdateBoxesBulk = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ 
      boxIds, 
      updates 
    }: { 
      boxIds: string[]; 
      updates: Partial<{
        theme: string;
        pieceId: string;
        zoneId: string;
      }> 
    }) => {
      const response = await apiClient.patch('/boxes/bulk/update', { boxIds, updates });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['boxes'] });
    },
  });
};

export const useMoveBoxesBulk = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ 
      boxIds, 
      pieceId, 
      zoneId 
    }: { 
      boxIds: string[]; 
      pieceId?: string; 
      zoneId?: string 
    }) => {
      const response = await apiClient.patch('/boxes/bulk/move', { boxIds, pieceId, zoneId });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['boxes'] });
    },
  });
};

export const useDeleteBoxesBulk = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (boxIds: string[]) => {
      const response = await apiClient.delete('/boxes/bulk/delete', { data: { boxIds } });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['boxes'] });
      queryClient.invalidateQueries({ queryKey: ['objets'] });
    },
  });
};

